var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "group-links-info" }, [
    _c(
      "div",
      { staticClass: "links-header" },
      [
        _c("info-main-block", {
          attrs: {
            "icon-photo": _vm.icon,
            "icon-text": _vm.name,
            "common-text": _vm.name,
            edit: _vm.isEditable,
            "icon-viewer": !!_vm.icon,
            "icon-type": "chat",
            "icon-id": _vm.cid,
          },
          on: { edit: _vm.doEditGroupChat },
        }),
        _c("div", { staticClass: "link-description" }, [
          _vm._v(_vm._s(_vm.$t("chat.group-link-description"))),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "links-content" }, [
      _c("div", { staticClass: "links-content-string" }, [
        _vm._v(_vm._s(_vm.$t("chat.link-str"))),
      ]),
      _vm.chatLink
        ? _c(
            "div",
            {
              staticClass: "links-content-link",
              attrs: { title: _vm.$t("chat.copy") },
              on: {
                click: function ($event) {
                  return _vm.copyChatLinkToClipBoard()
                },
              },
            },
            [_vm._v(_vm._s(_vm.chatLinkUrl))]
          )
        : _vm._e(),
      _vm.isAdmin
        ? _c(
            "div",
            {
              staticClass: "link circle-animation",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.openContextMenu($event)
                },
              },
            },
            [_c("i", { staticClass: "far fa-ellipsis-v" })]
          )
        : _vm._e(),
    ]),
    _vm.chatLink
      ? _c(
          "div",
          { staticClass: "links-actions" },
          [
            _c(
              "list-item",
              {
                staticClass: "color-blue",
                attrs: {
                  slot: "action",
                  title: _vm.$t("share-link"),
                  link: true,
                  chevron: false,
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.openShareLinkDialog()
                  },
                },
                slot: "action",
              },
              [
                _c(
                  "info-icon",
                  {
                    attrs: {
                      slot: "media",
                      "icon-color": "inherit",
                      "position-left": true,
                    },
                    slot: "media",
                  },
                  [
                    _c("i", {
                      staticClass: "fal fa-link",
                      attrs: { slot: "default" },
                      slot: "default",
                    }),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }